// @ts-check

import { ROUTE_LAYOUT, ROUTE_NAME } from '@/router/meta'
import { useLanguageStore } from '@/store/language'
import BaseViewVisitor from '@/views/BaseViewVisitor.vue'

/** @type {import('vue-router').RouteRecordRaw[]} */
export const registrationRoutes = [
  {
    path: '/registration',
    name: 'registration',
    component: () => import('@/views/Registration.vue'),
    meta: {
      showInMainNav: false,
      requiresAuth: false,
      [ROUTE_LAYOUT]: BaseViewVisitor,
      [ROUTE_NAME]: 'registration'
    }
  },
  {
    path: '/registration2',
    redirect: { name: 'registration' }
  },
  {
    path: '/en/registration',
    name: 'registration_en',
    beforeEnter: async (to, from, next) => {
      const { changeLanguage } = useLanguageStore()
      await changeLanguage('en')
      next({ name: 'registration', query: { ...to.query } })
    },
    component: () => import('@/views/Registration.vue'),
    meta: {
      showInMainNav: false,
      requiresAuth: false,
      [ROUTE_LAYOUT]: BaseViewVisitor,
      [ROUTE_NAME]: 'registration_en'
    }
  },
  {
    path: '/en/registration2',
    redirect: { name: 'registration_en' }
  },
  // @NOTE: This is a temporary solution and will be removed soon once a HTTP Redirect has been implemented in cloudfront
  {
    path: '/registration/:id',
    redirect: { name: 'registration' },
    meta: {
      showInMainNav: false,
      requiresAuth: false,
      [ROUTE_LAYOUT]: BaseViewVisitor,
      [ROUTE_NAME]: 'registration'
    }
  }
]

export default registrationRoutes
